class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
    this.url = this.dataset.url;
    this.observer = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting) {
        this.load();
      }
    });
  }

  connectedCallback() {
    if (this.url) {
      this.observer.observe(this);
    }
  }

  disconnectedCallback() {
    this.observer.disconnect();
  }

  load() {
    if (this.dataset.loaded) return;
    this.dataset.loaded = 'true';
    fetch(this.url)
      .then((res) => res.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const section = html.querySelector('[data-product-recommendations]');
        if (!section) {
          this.remove();
          return;
        }
        const grid = section.querySelector('[data-recommendations-grid]');
        if (!grid) {
          this.remove();
          return;
        }
        const src = section.querySelector('.page-width');
        this.querySelector('.page-width').replaceWith(src);
        if (window.Branzos) {
          window.Branzos.initReveal();
          window.Branzos.initQtySelectors();
        }
      })
      .catch(() => {});
  }
}

customElements.define('product-recommendations', ProductRecommendations);
